var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 1.5C13.25 1.03516 13.6328 0.625 14.125 0.625C14.5898 0.625 15 1.03516 15 1.5V5.875C15 7.32422 13.8242 8.5 12.375 8.5H3.98047L5.97656 10.5234C6.33203 10.8516 6.33203 11.4258 5.97656 11.7539C5.64844 12.1094 5.07422 12.1094 4.74609 11.7539L1.24609 8.25391C0.890625 7.92578 0.890625 7.35156 1.24609 7.02344L4.74609 3.52344C5.07422 3.16797 5.64844 3.16797 5.97656 3.52344C6.33203 3.85156 6.33203 4.42578 5.97656 4.75391L3.98047 6.75H12.375C12.8398 6.75 13.25 6.36719 13.25 5.875V1.5Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/return.be0dce6f1b3f2bc01550211187ceaafc.svg";
export { ForwardRef as ReactComponent };